import { useMemo, useState } from "react";
import { CATEGORIES } from "@/data/products";
import { ProductCard } from "@/components/ProductCard";

export const Catalog = ({ items }) => {
  const [filter, setFilter] = useState("All");

  const visible = useMemo(
    () => (filter === "All" ? items : items.filter((p) => p.category === filter)),
    [items, filter]
  );

  const counts = useMemo(() => {
    const map = {};
    for (const p of items) map[p.category] = (map[p.category] || 0) + 1;
    return map;
  }, [items]);

  return (
    <section id="catalog" data-testid="catalog-section" className="border-b hairline">
      <div className="max-w-6xl mx-auto px-6 py-20 sm:py-28">
        <div className="flex flex-col md:flex-row md:items-end md:justify-between gap-8 mb-12">
          <div>
            <p className="font-mono text-[11px] uppercase tracking-[0.3em] text-brass mb-4">
              The Catalogue
            </p>
          </div>
          <div className="flex flex-wrap gap-2" data-testid="catalog-filters">
            {["All", ...CATEGORIES].map((cat) => (
              <button
                key={cat}
                data-testid={cat === "All" ? "catalog-filter-all" : `catalog-filter-category-${cat.toLowerCase().replace(/[^a-z]/g, "-")}`}
                onClick={() => setFilter(cat)}
                className={`font-mono text-[11px] uppercase tracking-[0.2em] px-4 py-2 border transition-colors duration-200 ${
                  filter === cat
                    ? "bg-charcoal text-parchment border-charcoal"
                    : "border-charcoal/20 text-charcoal/60 hover:border-brass/60 hover:text-brass"
                }`}
              >
                {cat}
                <span className="ml-2 opacity-60">
                  {cat === "All" ? items.length : counts[cat] || 0}
                </span>
              </button>
            ))}
          </div>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8 sm:gap-10">
          {visible.map((p, i) => (
            <ProductCard key={p.code} product={p} index={i} />
          ))}
        </div>
      </div>
    </section>
  );
};
